module.exports = __webpack_public_path__ + "img/title.d19cb0b3.png";